import ModuleMultiColumnCourses from './ModuleMultiColumnCourses';

export default ModuleMultiColumnCourses;
export * from './ModuleMultiColumnCourses';
